import React from 'react';
import { JiraBottomRightCornerOutlet } from '@atlassian/jira-layout-controller';
import { RoadmapTimelineMode } from '@atlassian/jira-software-roadmap-timeline-table-kit';
import {
	useInteractionMetrics,
	TIMELINE_MODE_CHANGED,
} from '../../../../common/utils/interaction-metrics';
import { useTimelineUI } from '../../../../controllers/timeline-ui';

export const ChartOverlayButton = () => {
	const interactionMetrics = useInteractionMetrics();

	const [, { setTimelineMode }] = useTimelineUI();

	return (
		<JiraBottomRightCornerOutlet orderFromRight={2} id="business-timeline-overlay">
			<RoadmapTimelineMode
				onClick={(mode) => {
					interactionMetrics[TIMELINE_MODE_CHANGED].start();
					setTimelineMode(mode);
				}}
				withContainerStyles
			/>
		</JiraBottomRightCornerOutlet>
	);
};
